<template>
  <div>
    <nav
        class="
        header-navbar
        navbar navbar-expand-lg
        align-items-center
        navbar-light navbar-shadow
    ">
      <div class="navbar-container d-flex justify-content-between">
        <div class="bookmark-wrapper d-flex align-items-center">
          <div class="h-40">
            <router-link :to="{name: 'career'}" class="nav-link nav-link-style d-flex p-10 btn btn-outline-primary">
              <i class="fas fa-briefcase mb-0 mr-5"></i>
              <span class="h5 d-sm-none d-xl-inline-block fw-bolder m-0">Career</span>
            </router-link>
          </div>
          <div v-if="isLoggedIn" class="h-40 ms-1">
            <router-link :to="{name: 'job-application-list'}" class="nav-link nav-link-style d-flex p-10 btn btn-outline-primary">
              <i class="fas fa-tasks mb-0 mr-5"></i>
              <span class="h5 d-sm-none d-xl-inline-block fw-bolder m-0">Job Application</span>
            </router-link>
          </div>
        </div>

        <ul class="nav navbar-nav ms-5">
          <li v-if="!isLoggedIn" class="nav-item">
            <router-link :to="{name: 'Login'}" class="nav-link nav-link-style d-flex p-10">
              <i class="fas fa-sign-in-alt mb-0 mr-5"></i>
              <span class="h5 d-sm-none d-xl-inline-block m-0">Sign In</span>
            </router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item dropdown dropdown-user">
            <a
                class="nav-link dropdown-toggle dropdown-user-link"
                id="dropdown-user"
                href="#"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
              <div class="user-nav d-sm-flex d-none">
                <span class="user-name fw-bolder">{{ user.name }}</span>
              </div>
              <span class="avatar"
              ><img
                  class="round"
                  :src="profile.photo"
                  alt="avatar"
                  height="40"
                  width="40" /><span class="avatar-status-online"></span
              ></span>
            </a>
            <div
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="dropdown-user"
            >
              <router-link :to="{'name': 'job-applicant-profile'}" class="dropdown-item">
                <a> <img style="margin-right: 10px;" width="14" src="/app-assets/images/icons/user.svg" alt=""> My Profile </a>
              </router-link>
              <a @click.prevent="logout" class="dropdown-item"
              ><img style="margin-right: 10px;" width="14" src="/app-assets/images/icons/power.svg" alt=""> Logout</a
              >
            </div>
          </li>
        </ul>
      </div>
    </nav>

    <slot />
  </div>
</template>

<script>
import {mapMutations, useStore} from "vuex";
import {computed, onMounted} from "vue";
import handleProfile from "@/services/modules/profile";

export default {
  name: 'JobLayout',

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    user() {
      return this.$store.state.user.user
    },
    profile() {
      return this.$store.state.user.profile
    },
    isLoggedIn() {
      return !!this.user && !!this.user.id
    }
  },

  methods: {
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("X-Public-Token");
      this.$router.push('/login')
    },
    ...mapMutations({
      setUser: 'user/setUser',
      setProfile: 'user/setProfile',
    }),

    async getProfile() {
      this.loading = true
      try {
        const res = await this.fetchProfileInfo()
        if (res.status) {
          this.setProfile(res.data)
        } else {
          this.showError(res.message)
        }
      } catch (e) {
        this.showError('Something went wrong during fetching profile info')
      } finally {
        this.loading = false
      }
    }
  },

  mounted() {
    if (this.isLoggedIn) {
      this.getProfile()
    }
  },

  created() {
    this.setUser()
  },

  setup() {
    const {fetchProfileInfo} = handleProfile()
    return {
      fetchProfileInfo
    }
  }
}


</script>
